/* eslint-disable import/prefer-default-export */
export const LABELS = {};

export enum SignatureType {
  LandlordSignature = 'LandlordSignature',
  LandlordInitials = 'LandlordInitials',
}
